import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {AiAgentsTableComponent} from "./components/ai-agents-table/ai-agents-table.component";
import {AiAgentsTableRowComponent} from "./components/ai-agents-table-row/ai-agents-table-row.component";
import {AiAgentSelectComponent} from "./components/ai-agent-select/ai-agent-select.component";

@NgModule({
  declarations: [
    AiAgentsTableComponent,
    AiAgentsTableRowComponent,
    AiAgentSelectComponent,
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: [
    AiAgentSelectComponent,
  ]
})

export class AiAgentsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAiAgentsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AiAgentsModule);
};

export const downgradedAiAgentsModule = downgradeModule(bootstrapAiAgentsModule);
